var prongHorn = prongHorn || {};

prongHorn.cookieWarning = prongHorn.cookieWarning || function () {


    this.init = function () {

        var allCookieWarnings = document.querySelectorAll('.cookieVideoWarning');

        function ShowCookieWarning() {
            if (!Cookiebot.consent.marketing) {

                allCookieWarnings.forEach(function (cookieWarning) {
                    cookieWarning.style.display = 'block';
                });
            }
        }

        window.addEventListener('CookiebotOnDialogDisplay', function () {
            ShowCookieWarning();

        })

        window.addEventListener('CookiebotOnLoad', function () {
            ShowCookieWarning();

        })      

    };


    // Public functions
    return {
        init: init,

    };

}();